import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'WeatherService',
    controller: 'Weather'
};
const methods = [
    'GetWeather'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const WeatherApi = ZJApi.defineNewApi('WeatherApi', factory);

export default WeatherApi;